/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OpenAPIv3AffectedToolset = {
  /**
   * The number of those tools with breaking changes or changes that need attention.
   */
  affectedToolCount: number;
  /**
   * The ID of the toolset.
   */
  id: string;
  /**
   * Whether the toolset is served as an MCP server.
   */
  mcpEnabled: boolean;
  /**
   * The MCP slug of the toolset, when it is served as an MCP server.
   */
  mcpSlug?: string | undefined;
  /**
   * The name of the toolset.
   */
  name: string;
  /**
   * Whether the MCP server has OAuth configured.
   */
  oauthConfigured: boolean;
  /**
   * The slug of the toolset.
   */
  slug: string;
  /**
   * The number of tools from this source in the toolset.
   */
  toolCount: number;
};

/** @internal */
export const OpenAPIv3AffectedToolset$inboundSchema: z.ZodMiniType<
  OpenAPIv3AffectedToolset,
  unknown
> = z.pipe(
  z.object({
    affected_tool_count: z.int(),
    id: z.string(),
    mcp_enabled: z.boolean(),
    mcp_slug: z.optional(z.string()),
    name: z.string(),
    oauth_configured: z.boolean(),
    slug: z.string(),
    tool_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "affected_tool_count": "affectedToolCount",
      "mcp_enabled": "mcpEnabled",
      "mcp_slug": "mcpSlug",
      "oauth_configured": "oauthConfigured",
      "tool_count": "toolCount",
    });
  }),
);

export function openAPIv3AffectedToolsetFromJSON(
  jsonString: string,
): SafeParseResult<OpenAPIv3AffectedToolset, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenAPIv3AffectedToolset$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenAPIv3AffectedToolset' from JSON`,
  );
}
